const mixin = {
  data() {
    return {
      getConvertState: false,
    };
  },
  methods: {
    customSetHourOnDate(date, hour) {
      if (hour) {
        let selectedDate = new Date(date);
        let selectedHour = new Date(hour);
        selectedDate = selectedDate.setHours(
          selectedHour.getHours(),
          selectedHour.getMinutes()
        );
        return new Date(selectedDate);
      }
      return null;
    },
    customConvertYear(date) {
      if (!this.getConvertState) {
        return this.convertYearToJalali(date);
      }
      return this.convertYearToGregorian(date);
    },
    customFullDateTimeConvert(date) {
      if (!this.getConvertState) {
        return `${this.convertFullDateToJalali(
          date
        )} - ${this.convertHourAndMinute(date)}`;
      }
      return `${this.convertFullDateToGregorian(
        date
      )} - ${is.convertHourAndMinuteToGregorian(date)}`;
    },
    customFullDateConvert(date) {
      if (!this.getConvertState) {
        return this.convertFullDateToJalali(date);
      }
      return this.convertFullDateToGregorian(date);
    },
    customConvertMonth(date) {
      if (!this.getConvertState) {
        return this.convertMonthToJalali(date);
      }
      return this.convertMonthToGregorian(date);
    },
    customConvertHourAndMinute(date) {
      if (!this.getConvertState) {
        return this.convertHourAndMinute(date);
      }
      return this.convertHourAndMinuteToGregorian(date);
    },
    customConvertWeekDay(date) {
      if (!this.getConvertState) {
        return this.convertWeekdayToJalali(date);
      }
      return this.convertWeekdayToGregorian(date);
    },
    customConvertDate(date) {
      if (!this.getConvertState) {
        return this.convertDayToJalali(date);
      }
      return this.convertDayToGregorian(date);
    },

    convertYearToJalali(date) {
      return new Date(date).toLocaleDateString("fa-IR", {
        year: "numeric",
      });
    },
    convertYearToGregorian(date) {
      return new Date(date).toLocaleDateString("en-US", {
        year: "numeric",
      });
    },
    convertFullDateToJalali(date) {
      return new Date(date).toLocaleDateString("fa-IR");
    },
    convertFullDateToGregorian(date) {
      return new Date(date).toLocaleDateString("en-GB");
    },
    convertWeekdayToGregorian(date) {
      return new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
      });
    },
    convertWeekdayToJalali(date) {
      return new Date(date).toLocaleDateString("fa-IR", {
        weekday: "long",
      });
    },
    convertDayToJalali(date) {
      return new Date(date)
        .toLocaleDateString("fa-IR", {
          day: "numeric",
        })
        .replace("م", "");
    },
    convertMonthToJalali(date) {
      return new Date(date).toLocaleDateString("fa-IR", {
        month: "long",
      });
    },
    convertDayToGregorian(date) {
      return new Date(date).toLocaleDateString("en-US", {
        day: "numeric",
      });
    },
    convertMonthToGregorian(date) {
      return new Date(date).toLocaleDateString("en-US", {
        month: "long",
      });
    },
    convertHourAndMinute(date) {
      return new Date(date).toLocaleTimeString("fa-IR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    convertHourAndMinuteToGregorian(date) {
      return new Date(date).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
};

export default mixin;
